import { Checkbox, DatePicker, Drawer, Form, message, Select, Space, Switch } from "antd";
import { FC, useCallback, useEffect, useState } from "react";

import moment from "moment";

//!STYLE
import { AppNotification } from "components/appNotification";
import AppButton from "components/libs/button";
import { useDispatch, useSelector } from "react-redux";
import {
  displayDrawerAdsSpecific,
  setCurrentCreneau,
} from "store/adventissements";
import {
  useCreateAdSpecificMutation,
  useGetAllAdSpecificQuery,
  useUpCreSpecMutation,
  useUpdateAdSpecificMutation,
} from "store/services/teacher/ads.services";
import {
  filterHoursByCurrentTime,
  handleClearNiveauMatUser,
  hours
} from "utils/formats";
import s from "../../TeacherAds/components/style.module.css";

//!Images
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";
import axios, { AxiosResponse } from "axios";
import { removeDuplicates, StatusCode, UserRoles } from "common/enums";
import { setIsCalendarUpdated } from "store/app/appSlice";
import { useGetOrganismRoomsQuery } from "store/services/teacher/classes.services";
import AlbertIcon from "../../../../assets/images/app/albert_icon.svg";
import ArrowBack from "../../../../assets/images/app/arrow_back.svg";

const { Option } = Select;

interface CustomResponse {
  statusCode: number;
  message: string;
  data: any;
}

interface DrawerAdsCreneauSpecificProps {
  isCollective?: boolean;
  className?: string,
  classeId?: string
  teacher?: any,
  coursePrice?: any,
}

const DrawerAdsCreneauSpecific: FC<DrawerAdsCreneauSpecificProps> = ({ isCollective, className, classeId, teacher, coursePrice }) => {
  //!HOOKS
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { refetch } = useGetAllAdSpecificQuery(user?._id);
  const [createAdSpecific, { isLoading, isError, isSuccess, data: creneauData, error: creneauError }] = useCreateAdSpecificMutation();

  const [updateAdSpecific, { isLoading: isLoadingUpdate, isError: isErrorUpdate, isSuccess: isSuccessUpdate }] =
    useUpdateAdSpecificMutation();

  const [
    upCreSpec,
    { isLoading: isLoadingUp, isSuccess: isSuccessUp, isError: isErrorUp },
  ] = useUpCreSpecMutation();

  const { drawerAdsSpecific, currentCreneau } = useSelector(
    (state) => state.drawerAds
  );

  const { data: organismRooms, isLoading: loadingOrganismRooms, refetch: refetchOrganismRooms } = useGetOrganismRoomsQuery(teacher?._id);

  const { userHavingCalendar } = useSelector((state) => state.app);

  //!STATES
  const [tempTopic, setTempTopic] = useState<any>([]);
  const [date, setDate] = useState<string>("");

  const [selectedHour, setSelectedHour] = useState<any>("");
  const [startingHour, setStartingHour] = useState<any>("08:00");
  const [endingHour, setEndingHour] = useState<any>("09:00");
  const [isThirty, setIsThirty] = useState<boolean>(false);

  const [checkedLevels, setCheckedLevels] = useState<boolean>(true);
  const [isBooking, setIsBooking] = useState<boolean>(false);
  const [selectedGourp, setSelectedGourp] = useState<any>([]);
  const [userLevels, setUserLevels] = useState<any>();

  const [classeValue, setClasseValue] = useState<string>("");

  const [courseStartingTime, setCourseStartingTime] = useState<any>();
  const [courseEndingTime, setCourseEndingTime] = useState<any>();

  const handleClasseValue = (value: string) => {
    console.log(value);
    setClasseValue(value);
  }

  const handleChange = (checked: boolean) => {
    if (checked) {
      setCheckedLevels(true);
      setSelectedGourp((prev: any) => {
        return [];
      });
    }
    else {
      setCheckedLevels(false);
    }
  };

  const handleCloseDrawer = () => {
    dispatch(displayDrawerAdsSpecific(false));
    dispatch(setCurrentCreneau({}));
    setSelectedGourp((prev: any) => {
      return [];
    });
    setCheckedLevels(true);

    form.setFieldsValue({
      one: "08:00",
      two: "09:00",
    });

    setStartingHour("08:00");
    setEndingHour("09:00");
  }

  const handleGroupClick = (group: any) => {
    setSelectedGourp((prev: any[]) => {
      const isGroupSelected = prev.some(selected => selected.levelGroup === group.levelGroup);
      if (isGroupSelected) {
        return prev.filter(selected => selected.levelGroup !== group.levelGroup);
      } else {
        return [...prev, group];
      }
    });
  };

  const handleStartingChange = (value: any) => {
    setSelectedHour(value);
    setStartingHour(value);
  };

  const handleEndingChange = (value: any) => {
    setEndingHour(value);
  };

  function estIdMongoDB(chaine: string): boolean {
    const pattern = /^[0-9a-fA-F]{24}$/;
    return pattern.test(chaine);
  }

  const onSelectLevel = useCallback(async (levelId: string) => {
    return user?.nivMat
      .filter((nivMat: any) => {
        return nivMat?.niveau?._id === levelId;
      })
      .forEach((matiere: any) => {
        return setTempTopic(matiere?.matieres);
      });
  }, []);

  function checkCreneauExists(creneauData: any, data: any): boolean {
    return data.some((item: any) => {
      // Compare only the YYYY-MM-DD part
      const dayData = new Date(item.day).toISOString().split("T")[0];
      const dayCreneau = new Date(creneauData.niches.date).toISOString().split("T")[0];

      if (dayData !== dayCreneau) return false;

      // If date matches, check time ranges
      return item.niches.some((niche: any) => {
        const cStart = creneauData.niches.timeRanges[0].range[0].hour;
        const cEnd = creneauData.niches.timeRanges[0].range[1].hour;

        return niche.timeRanges.some((range: any) => range.includes(cStart)) &&
          niche.timeRanges.some((range: any) => range.includes(cEnd));
      });
    });
  }

  const getTimeDifferenceInMinutes = (time1: string, time2: string) => {
    const [hours1, minutes1] = time1.split(":").map(Number);
    const [hours2, minutes2] = time2.split(":").map(Number);

    const totalMinutes1 = hours1 * 60 + minutes1;
    const totalMinutes2 = hours2 * 60 + minutes2;

    return Math.abs(totalMinutes2 - totalMinutes1);
  };

  const onFinish = useCallback(
    async (values: any) => {

      setCourseStartingTime(values?.one);
      setCourseEndingTime(values?.two);

      try {
        const response: AxiosResponse<CustomResponse> = teacher ? await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${teacher?._id}`) : await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${user?._id}`);
        if (response.status === StatusCode.OK) {
          const data = response?.data?.data;
          if (data) {
            if (currentCreneau?.date) {
              const concatenatedLevelGroups = selectedGourp.map((group: any) => group.levelGroup).join("$");
              const updateData = {
                teacherId: user?._id,
                oldTimeSlot: {
                  date: currentCreneau?.day,
                  grouplevels: [currentCreneau?.grouplevels],
                  level: [currentCreneau?.level?._id],
                  topic: [currentCreneau?.topic?._id],
                  timeRanges: [
                    {
                      range: [
                        {
                          hour: currentCreneau?.timeRanges[0],
                        },
                        {
                          hour: currentCreneau?.timeRanges[1],
                        }
                      ]
                    }
                  ]
                },
                newTimeSlot: [
                  {
                    grouplevels: [concatenatedLevelGroups],
                    date: values.date._d,
                    timeRanges: [
                      {
                        range: [
                          {
                            hour: values?.one,
                          },
                          {
                            hour: values?.two,
                          },
                        ],
                      },
                    ],
                  },
                ],
              };
              updateAdSpecific(updateData);
            }
            else {
              if (Number(values.one.split(":")[0]) >= Number(values.two.split(":")[0])) {
                AppNotification("Les créneaux de 30 minutes ne sont pas valides! Merci de sélectionner une durée minimale de 1 heure pour tes disponibilités.", "AlbertSad");
              }
              else {
                const concatenatedLevelGroups = selectedGourp.map((group: any) => group.levelGroup).join("$");

                const finalData = {
                  teacherId: user?._id,
                  niches: {
                    grouplevels: checkedLevels ? [""] : [concatenatedLevelGroups],
                    date: values.date._d,
                    timeRanges: [
                      {
                        range: [
                          {
                            hour: values?.one,
                          },
                          {
                            hour: values?.two,
                          },
                        ],
                        type: "individuel",
                      },
                    ],
                  },
                };

                const collectiveFinalData = {
                  teacherId: teacher ? teacher?._id : user?._id,
                  niches: {
                    grouplevels: checkedLevels ? [""] : [concatenatedLevelGroups],
                    date: values.date._d,
                    timeRanges: [
                      {
                        range: [
                          {
                            hour: values?.one,
                          },
                          {
                            hour: values?.two,
                          },
                        ],
                        type: "collectif",
                      },
                    ],
                  },
                  "isCollective": true,
                  "classeId": values?.className ? values?.className : classeValue,
                  "organismeId": user?.roles?.includes(UserRoles?.ORGANISME) ? user?._id : "",
                };

                const exists = checkCreneauExists(isCollective ? collectiveFinalData : finalData, data);

                if (exists) {
                  message.error("Créneau déjà existant !");
                } else {
                  createAdSpecific(isCollective ? collectiveFinalData : finalData);
                }
              }
            }
          }
          else {
            AppNotification("Tu dois créer en premier un calendrier de disponibilité.", "AlbertSad");
          }
        }
        else {
          AppNotification("Tu dois créer en premier un calendrier de disponibilité.", "AlbertSad");
        }
      }
      catch (error) {
        AppNotification("Tu dois créer en premier un calendrier de disponibilité.", "AlbertSad");
      }
    },
    [currentCreneau, upCreSpec, user, selectedGourp, classeValue]
  );

  const handleConfirmReservation = async (courseData: any) => {

    const bookingPrice = 1;
    const timeDifference = getTimeDifferenceInMinutes(courseStartingTime, courseEndingTime);
    const finalPrice = (bookingPrice * timeDifference) / 60;

    try {
      const reservationData = {
        classeId: courseData?.classeId,
        creneauId: courseData?.niches[0]?.idCreneau,
        pricePerStudent: finalPrice,
        range: [courseStartingTime + ":" + courseEndingTime],
        byCredits: false,
        startDate: courseData?.day + "T" + `${courseStartingTime}:00.000Z`,
        organismId: user?._id,
        teacherId: teacher ? teacher?._id : ""
      };

      const response = await axios.post(`${API_RESSOURCES}/advertisements/collective/reservation`, reservationData);

      if (response.status === StatusCode.CREATED) {
        message.success("Créneau ajouté et réservé avec succès");
        dispatch(displayDrawerAdsSpecific(false));
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        message.error("Erreur survenue lors de la création du cours");
      }
    } catch (error) {
      message.error("Erreur survenue lors de la création du cours");
    }
  };

  useEffect(() => {
    if (isSuccess) {
      if (isBooking) {
        handleConfirmReservation(creneauData?.data);

        form.resetFields();
        setSelectedGourp((prev: any) => {
          return [];
        });
        setCheckedLevels(true);

        form.setFieldsValue({
          one: "08:00",
          two: "09:00",
        });

        setStartingHour("08:00");
        setEndingHour("09:00");
      }
      else {
        message.success("Créneau ajouté avec succès");
        dispatch(displayDrawerAdsSpecific(false));
        setTimeout(() => {
          if (isCollective) {
            window.location.reload();
          }
          else {
            dispatch(setIsCalendarUpdated(true));
          }
        }, 3000);
        form.resetFields();
        setSelectedGourp((prev: any) => {
          return [];
        });
        setCheckedLevels(true);

        form.setFieldsValue({
          one: "08:00",
          two: "09:00",
        });

        setStartingHour("08:00");
        setEndingHour("09:00");
      }
    }
    if (isError) {
      if (isBooking) {
        if (creneauError && "data" in creneauError) {
          const err = creneauError.data as any;
          if (err?.statusCode === 409) {
            handleConfirmReservation(err?.data);
          }
          else {
            message.error("Ce créneau est déjà réservé !");
          }
        } else {
          message.error("Une erreur est survenue");
        }
      }
      else {
        message.error("Créneau déjà existant !");
      }
    }
  }, [isSuccess, isLoading, isError, creneauData]);

  useEffect(() => {
    if (isSuccessUpdate) {
      message.success("Créneau ajouté avec succès");
      dispatch(displayDrawerAdsSpecific(false));
      setTimeout(() => {
        if (isCollective) {
          window.location.reload();
        }
        else {
          dispatch(setIsCalendarUpdated(true));
        }
      }, 3000);
      form.resetFields();
      setSelectedGourp((prev: any) => {
        return [];
      });
      setCheckedLevels(true);

      form.setFieldsValue({
        one: "08:00",
        two: "09:00",
      });

      setStartingHour("08:00");
      setEndingHour("09:00");
    }
    if (isErrorUpdate) {
      message.error("Créneau déjà existant !");
    }
  }, [isSuccessUpdate, isLoadingUpdate, isErrorUpdate]);

  useEffect(() => {
    if (currentCreneau?.date) {
      form.setFieldsValue({
        date: moment(currentCreneau?.day) || "",
        one: currentCreneau?.timeRanges[0] || "",
        two: currentCreneau?.timeRanges[1] || "",
        levelIds: currentCreneau?.level?._id || "",
        matiere: currentCreneau?.topic?.title || "",
        type: currentCreneau?.creneauTypes || "",
      });

      if (currentCreneau?.grouplevels) {
        setCheckedLevels(false);
        const levelsArray = currentCreneau?.grouplevels.split("$");
        const levelGroups = removeDuplicates(user?.groupLevels);
        const selected = levelGroups.filter((group: any) => levelsArray.includes(group.levelGroup));
        setSelectedGourp(selected);
      } else {
        setCheckedLevels(true);
      }
    } else {
      form.resetFields();
    }
  }, [currentCreneau]);

  useEffect(() => {
    if (selectedHour.toString().includes("30")) {
      setIsThirty(true);
    }
    else {
      setIsThirty(false);
    }
  }, [selectedHour]);

  useEffect(() => {
    form.setFieldsValue({
      one: "08:00",
      two: "09:00",
    });

    setStartingHour("08:00");
    setEndingHour("09:00");
  }, []);

  useEffect(() => {
    const uniqueLevels = removeDuplicates(user?.groupLevels);
    setUserLevels(uniqueLevels);
  }, [user]);

  useEffect(() => {
    if (classeId) {
      console.log("classeId : ", classeId);
    }
    else {
      console.log("classeId : No classeId");
    }
  }, [classeId]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [isXsScreen, setIsXsScreen] = useState(window.innerWidth > 767 && window.innerWidth <= 1151);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth > 1151 && window.innerWidth <= 1321);
  const [isMediumScreen, setIsMediumScreen] = useState(window.innerWidth > 1321 && window.innerWidth <= 1606);
  const [isNormalScreen, setIsNormalScreen] = useState(window.innerWidth > 1606 && window.innerWidth <= 1799);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
    setIsXsScreen(window.innerWidth > 767 && window.innerWidth <= 1151);
    setIsSmallScreen(window.innerWidth > 1151 && window.innerWidth <= 1321);
    setIsMediumScreen(window.innerWidth > 1321 && window.innerWidth <= 1606);
    setIsNormalScreen(window.innerWidth > 1606 && window.innerWidth <= 1799);
  };
  window.addEventListener('resize', handleResize);

  return (
    <Drawer
      className="drawer"
      onClose={handleCloseDrawer}
      visible={drawerAdsSpecific}
      width={isMobile ? "100%" : isXsScreen ? "100%" : isSmallScreen ? "60%" : isMediumScreen ? "60%" : isNormalScreen ? "40%" : "40%"}
      title={
        <div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
          {currentCreneau?.date ? <h3>Replanifier un créneau</h3> : <h3>Ajouter un créneau</h3>}
          {/* <span style={{ fontSize: isMobile ? "0.7em" : "16px" }}>{user?.fuseauHorraire.substring(6)}</span> */}
          {user?.fuseauHorraire && <div className="fuseauBox">
            Fuseau horaire : <span>{user?.fuseauHorraire.split(" ")[1] + " " + user?.fuseauHorraire.split(" ")[2] + " " + user?.fuseauHorraire.split(" ")[3]}</span>
          </div>}
        </div>
      }
      headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
      closeIcon={
        <img
          src={ArrowBack}
          height={isMobile ? 10 : 18}
          style={{}}
        ></img>
      }
      drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "30px", borderBottomLeftRadius: isMobile ? "0px" : "30px", boxShadow: "-3px 3px 34px #39393929" }}
    >
      <Form onFinish={onFinish} form={form}>
        <div className={s.drawerBody}>
          <div className={s.dateBox}>
            <span>Date</span>
            <div className={s.datePickerBox}>
              <Form.Item
                style={{ margin: 0 }}
                rules={[
                  {
                    required: true,
                    message: "Ce champ est requis",
                  },
                ]}
                name={"date"}
                className={s.datePicker}
              >
                <DatePicker
                  bordered={false}
                  className={s.datePickerInput}
                  disabledDate={(current) => {
                    return (
                      moment().add(-1, "days") >= current ||
                      moment().add(3, "month") <= current
                    );
                  }}
                  style={{ height: isMobile ? "30px" : "40px", width: "100%", fontSize: "10px" }}
                  onChange={(_, date: string) => setDate(date)}
                />
              </Form.Item>
            </div>
          </div>
          <div className={s.timeBox}>
            <div className={s.timeTitle}>Créneau</div>
            <div className={s.selectBox}>
              <div className={s.timePicker}>
                <Form.Item
                  style={{ margin: 0, padding: 0 }}
                  rules={[
                    {
                      required: true,
                      message: "Ce champ est requis",
                    },
                  ]}
                  name={"one"}
                  initialValue={startingHour}
                >
                  <Select
                    showSearch
                    defaultValue="08:00"
                    value={startingHour}
                    placeholder="Heures"
                    style={{ width: "100%" }}
                    bordered={false}
                    onChange={handleStartingChange}
                    options={filterHoursByCurrentTime(hours, date).map((hour) => {
                      return {
                        value: hour.value,
                        label: hour.label,
                      };
                    })}
                  />
                </Form.Item>
              </div>
              <div>À</div>
              <div className={s.timePicker}>
                <Form.Item
                  style={{ margin: 0, padding: 0 }}
                  name={["two"]}
                  rules={[
                    {
                      required: true,
                      message: "Ce champ est requis",
                    },
                  ]}
                  initialValue={endingHour}
                >
                  <Select
                    showSearch
                    defaultValue={"09:00"}
                    value={endingHour}
                    placeholder="Heures"
                    style={{ width: "100%" }}
                    bordered={false}
                    onChange={handleEndingChange}
                    options={filterHoursByCurrentTime(hours, date).map((hour) => {
                      return {
                        value: hour.value,
                        label: hour.label,
                      };
                    })}
                  />
                </Form.Item>
              </div>
            </div>
          </div>

          {!isCollective && <div className={s.levelsBox}>
            Afficher ce créneau pour tous niveaux
            <Switch
              style={{ backgroundColor: checkedLevels ? "#7FB1B2" : "#868686", marginLeft: "30px" }}
              checked={checkedLevels}
              onChange={handleChange}
            />
          </div>}

          {!isCollective && !checkedLevels && <div className={s.levelsButtons}>
            {userLevels.map((group: any) => (
              <div
                key={group?.levelGroup}
                onClick={() => handleGroupClick(group)}
                className={`${selectedGourp.some((selected: any) => selected.levelGroup === group.levelGroup) ? s.levelButtonActive : s.levelButton}`}
              >
                {group?.levelGroup}
              </div>
            ))}
          </div>}

          {isCollective && <Space align="center" style={{ marginTop: "20px", fontSize: "1.2em", width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
            {/* Checkbox checked by default and locked */}
            <Checkbox checked style={{ fontSize: "1.05em", fontWeight: "400", color: "#707070" }}>
              Cours collectif
            </Checkbox>

            {/* Select input */}
            {!teacher && classeId ? <div className={s.classPicker}>
              <Form.Item
                style={{ margin: 0, padding: 0 }}
                name={["className"]}
                rules={[
                  {
                    required: true,
                    message: "Ce champ est requis",
                  },
                ]}
                initialValue={classeId}
              >
                <Select
                  defaultValue={classeId}
                  value={classeId}
                  style={{ width: "100%" }}
                  bordered={false}
                >
                  <Option value={classeId}>{className}</Option>
                </Select>
              </Form.Item>
            </div> : !loadingOrganismRooms && classeId ? <div className={s.classPicker}>
              <Form.Item
                style={{ margin: 0, padding: 0 }}
                name={["className"]}
                rules={[
                  {
                    required: true,
                    message: "Ce champ est requis",
                  },
                ]}
                initialValue={classeId}
              >
                <Select
                  defaultValue={classeId}
                  value={classeId}
                  style={{ width: "100%" }}
                  bordered={false}
                >
                  <Option value={classeId}>{className}</Option>
                </Select>
              </Form.Item>
            </div> : <div className={s.organismClassPicker}>
              <Form.Item
                style={{ margin: 0, padding: 0 }}
                name={["className"]}
                rules={[
                  {
                    required: true,
                    message: "Ce champ est requis",
                  },
                ]}
              >
                <Select
                  value={classeValue}
                  style={{ width: "100%" }}
                  bordered={false}
                  placeholder="Choisis une classe"
                  onChange={handleClasseValue}
                >
                  {organismRooms?.data?.map((room: any, index: number) => (
                    <Option key={index} value={room?._id}>{room?.title}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>}
          </Space>}

          <div className={s.addButtonBox}>
            <Form.Item style={{ margin: 0, padding: 0 }}>
              <AppButton className={s.newMoveButton} loading={isLoading || isLoadingUp || isLoadingUpdate} htmlTypeSubmit={true}>
                Ajouter le créneau
              </AppButton>
            </Form.Item>

            {user?.roles?.includes(UserRoles?.ORGANISME) && <Form.Item style={{ margin: 0, padding: 0 }}>
              <AppButton className={s.newBookButton} loading={isLoading || isLoadingUp || isLoadingUpdate} htmlTypeSubmit={true} onClick={() => setIsBooking(true)}>
                Réserver le créneau
              </AppButton>
            </Form.Item>}
          </div>

          <div className={s.albertBox}>
            <img src={AlbertIcon} height={isMobile ? 150 : 300}></img>
          </div>

          <div className={s.full__content} style={{ display: "none" }}>
            <div className={s.field__content}>
              <div className={s.field}>
                <Form.Item
                  style={{ margin: 0, padding: 0 }}
                  rules={[
                    {
                      required: false,
                      message: "Ce champ est requis",
                    },
                  ]}
                  name={"levelIds"}
                >
                  <Select
                    placeholder="Choisis un niveau"
                    style={{ width: "100%" }}
                    className={s.select}
                    bordered={false}
                    onChange={(value: string, fullValues: object) => {
                      onSelectLevel(value);
                    }}
                    options={handleClearNiveauMatUser(user?.nivMat)?.map(
                      (item: any) => {
                        return {
                          label: item?.niveau?.levelGroup,
                          options: [
                            {
                              label: item?.niveau?.title,
                              value: item?.niveau?._id,
                            },
                          ],
                        };
                      }
                    )}
                  />
                </Form.Item>
              </div>

              <div className={s.field}>
                <Form.Item
                  style={{ margin: 0, padding: 0 }}
                  rules={[
                    {
                      required: false,
                      message: "Ce champ est requis",
                    },
                  ]}
                  name={"matiere"}
                >
                  <Select
                    className={s.select}
                    placeholder="Choisis une matière"
                    style={{ width: "100%" }}
                    bordered={false}
                    allowClear
                  >
                    {tempTopic?.map((topic: any) => (
                      <Option
                        key={topic?.matiere?._id}
                        value={topic?.matiere?._id}
                      >
                        {topic?.matiere?.title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className={s.field}>
                <Form.Item
                  style={{ margin: 0, padding: 0 }}
                  rules={[
                    {
                      required: false,
                      message: "Ce champ est requis",
                    },
                  ]}
                  name={"type"}
                >
                  <Select
                    defaultValue={"individuel"}
                    className={s.select}
                    placeholder="Choisis un type de créneau"
                    style={{ width: "100%" }}
                    bordered={false}
                    allowClear
                    value={"individuel"}
                  >
                    <Option value={"individuel"}>Individuel</Option>
                    <Option value={"collectif"}>Collectif</Option>
                  </Select>
                </Form.Item>
              </div>
            </div>
          </div>

        </div>
      </Form>
    </Drawer>
  );
};

export default DrawerAdsCreneauSpecific;
